/* eslint-disable */

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import HomeData from "../../../data/home.json";
import Brand from "../../../components/brand/index";
import SectionTitle from "../../../components/section-title";
import { Virtual } from "swiper";
// import { Autoplay } from "swiper";

// SwiperCore.use([Autoplay]);


const BrandContainer = () => {
    const swiperOption = {
        
        loop: true,
        speed: 800,
        autoplay: {
            delay: 2500,
            disableOnInteraction: true,
        },
        slidesPerView: 3,
        spaceBetween: 0,
        pagination: false,
        navigation: true,
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: 2,
            },
            // when window width is >= 480px
            480: {
                slidesPerView: 2,
            },
            // when window width is >= 640px
            768: {
                slidesPerView: 3,
            },

            // when window width is >= 640px
            992: {
                slidesPerView: 3,
            },
        },
    };
    return (
        <div className="brand-section section-p py-10">
            <div className="container">
                <div className="row">
                    <div className="col-xl-6 col-lg-8 mx-auto">
                        <SectionTitle
                        classOption="title-section mb-1 pb-5 text-center"
                        subTitle="Clients"
                        title="<span class='text-primary'>Our</span> Clients"
                        excerptClassOption="null"
                        // excerpt="Pleasure rationally encounter consequences that are <br class='d-none d-xl-block' /> painful. Nor again is there anyone who pursues"
                         />
                     </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <Swiper className="brand-carousel" {...swiperOption}>
                            {HomeData[1].brand &&
                                HomeData[1].brand.map((single, key) => {
                                    return (
                                        <SwiperSlide key={key}>
                                            <Brand key={key} data={single} />
                                        </SwiperSlide>
                                    );
                                })}
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BrandContainer;
